module.exports = __webpack_public_path__ + "img/539.33196513.png";